import React, { useCallback, useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import { AutomationRulesContext } from '../../context';
import messages from '../../messages';
import style from './styles.module.less';

const OpenDeleteModalDropdownMenuItem = ({ automationRuleId }) => {
  const { openDeleteModal } = useContext(AutomationRulesContext);
  const onOpenModal = useCallback(() => {
    openDeleteModal(automationRuleId);
  }, [openDeleteModal, automationRuleId]);

  return (
    <DropdownMenuItem className={style.danger} onClick={onOpenModal}>
      <FormattedMessage {...messages.delete} />
    </DropdownMenuItem>
  );
};

OpenDeleteModalDropdownMenuItem.propTypes = {
  automationRuleId: PropTypes.string.isRequired,
};

export default OpenDeleteModalDropdownMenuItem;
